export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    ActionPayload: [
      "ActionPayloadLocationProfileChanged",
      "ActionPayloadPostEnabled",
    ],
    AnimationOption: [
      "AnimationOptionFade",
      "AnimationOptionFlip",
      "AnimationOptionWipe",
    ],
    ConditionValueType: [
      "ConditionValueTypeBoolean",
      "ConditionValueTypeNumber",
      "ConditionValueTypeString",
    ],
    ExtraFieldType: [
      "ExtraFieldTypeArray",
      "ExtraFieldTypeBoolean",
      "ExtraFieldTypeBox",
      "ExtraFieldTypeColor",
      "ExtraFieldTypeHelp",
      "ExtraFieldTypeMedia",
      "ExtraFieldTypeNumber",
      "ExtraFieldTypeReference",
      "ExtraFieldTypeRichText",
      "ExtraFieldTypeSearch",
      "ExtraFieldTypeSelect",
      "ExtraFieldTypeText",
      "ExtraFieldTypeTextLabel",
    ],
  },
};
export default result;
